import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { Switch } from '@progress/kendo-react-inputs';
import { FormFieldWrapper } from '../FormFieldWrapper';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

interface FormSwitcherProps extends FieldRenderProps {
  isLoading?: boolean;
}

export const FormSwitcher: React.FC<FormSwitcherProps> = fieldRenderProps => {
  const { isLoading } = fieldRenderProps;
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <Switch
        name={fieldRenderProps.name}
        id={fieldRenderProps.id}
        value={fieldRenderProps.value}
        onChange={fieldRenderProps.onChange}
        onFocus={fieldRenderProps.onFocus}
        onBlur={fieldRenderProps.onBlur}
        valid={fieldRenderProps.valid}
        disabled={fieldRenderProps.disabled}
        onLabel={translate('custom.common.enable')}
        offLabel={translate('custom.common.disable')}
        validationMessage={fieldRenderProps.validationMessage || undefined}
        checked={fieldRenderProps.value}
      />
    </FormFieldWrapper>
  );
};
